export default __webpack_public_path__ + "static/media/bg_login.b20b5633.jpg";